<script setup lang="ts">
import SVG from '@/components/shared/SVG.vue';
import Tts from '@/components/shared/Tts.vue';
import BaseOverlay from '@/overlays/BaseOverlay.vue';
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['close']);

type Item = {
  picture?: {
    source: string;
  };
  title: string;
};

interface Props {
  items: Item[];
}

defineProps<Props>();

const { t } = useI18n();

const getArialLabel = (index: number, item: Item) => {
  return t('meeting.tts_agenda_point', {
    number: index + 1,
    title: item.title,
  });
};
</script>

<template>
  <BaseOverlay @close="emit('close')" :title="$t('meeting.agenda')">
    <template #tts>
      <Tts contentClassName="tts-agenda-content" />
    </template>
    <template #content>
      <div class="tts-agenda-content">
        <div
          class="sr-only"
          :aria-label="
            $t('meeting.agendaPointss_plural', {
              amount: items?.length || 0,
            })
          "
        ></div>
        <div
          v-for="(item, index) in items"
          :key="index"
          class="inline-flex w-full pb-10 items-center"
        >
          <img
            v-if="item.picture"
            :src="item.picture.source"
            :class="{ '-m-1': index !== 0 }"
            class="w-24 h-24 rounded-full border-4 shadow-small border-white mr-10"
            v-optimized="{ src: item.picture.source, size: 'small' }"
          />
          <div
            v-else
            :class="{ '-m-1': index !== 0 }"
            class="w-24 h-24 min-w-24 min-h-24 mr-10 flex items-center justify-center bg-white rounded-full border-4 shadow-small border-white"
          >
            <SVG
              class="text-neutral-700"
              icon="fas-tag"
              height="40"
              width="48"
            ></SVG>
          </div>

          <p class="label" :aria-label="getArialLabel(index, item)">
            {{ item.title }}
          </p>
        </div>
      </div>
    </template>
  </BaseOverlay>
</template>
